module.exports = __webpack_public_path__ + "img/icon-3.24326fe9.png";